import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "lot-detail"
}
const _hoisted_2 = {
  key: 0,
  class: "lot-detail-dis"
}
const _hoisted_3 = {
  key: 1,
  class: "lot-detail-dis"
}
const _hoisted_4 = {
  key: 2,
  class: "lot-detail-dis"
}
const _hoisted_5 = {
  key: 3,
  class: "lot-detail-dis"
}
const _hoisted_6 = {
  key: 4,
  class: "lot-detail-dis"
}
const _hoisted_7 = {
  key: 5,
  class: "lot-detail-dis flex gap-1"
}
const _hoisted_8 = {
  key: 6,
  class: "lot-detail-dis lot-detail-notes"
}
const _hoisted_9 = {
  key: 7,
  class: "lot-detail-dis lot-detail-notes"
}

import { ref, onMounted, nextTick, toRefs, inject, computed } from 'vue';
import ArrowDownIcon from '../assets/icons/ArrowDown.vue';
import { Lot } from '@/types';

export default /*@__PURE__*/_defineComponent({
  __name: 'LotSummary',
  props: {
    lotInformationData: {}
  },
  setup(__props: any) {

const props = __props;
const { lotInformationData } = toRefs(props);
const isPublicNotesExpanded = ref(false);
const isPrivateNotesExpanded = ref(false);
const showPublicReadMore = ref(false);
const showPrivateReadMore = ref(false);
const publicNotesRef = ref<HTMLElement | null>(null);
const privateNotesRef = ref<HTMLElement | null>(null);

const mode = inject('mode', ref(''));
const isLandView = computed(() => mode.value === 'land');

const togglePublicExpand = () => {
  isPublicNotesExpanded.value = !isPublicNotesExpanded.value;
};
const togglePrivateExpand = () => {
  isPrivateNotesExpanded.value = !isPrivateNotesExpanded.value;
};

onMounted(async () => {
  await nextTick();
  showPrivateReadMore.value = getElementReadmoreState(privateNotesRef.value)
  showPublicReadMore.value = getElementReadmoreState(publicNotesRef.value)
});

const getElementReadmoreState = (el: any) => {
 if (el) {
    const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
    const maxLines = 2;
    const maxHeight = lineHeight * maxLines;

    if (el.scrollHeight > maxHeight + 1) {
      return true;
    }
  }
  return false;
}

return (_ctx: any,_cache: any) => {
  return (_unref(lotInformationData))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h5", null, "Job " + _toDisplayString(_unref(lotInformationData).id) + " Information", 1),
        (_unref(lotInformationData).id)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "lot-detail-label" }, "Job ID", -1)),
              _createTextVNode(" " + _toDisplayString(_unref(lotInformationData).id), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(lotInformationData).net_premium)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "lot-detail-label" }, "Lot Differential", -1)),
              _createTextVNode(" $" + _toDisplayString(_unref(lotInformationData).net_premium.toLocaleString()), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(lotInformationData).garage_hand)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "lot-detail-label" }, "Garage Hand", -1)),
              _createTextVNode(" " + _toDisplayString(_unref(lotInformationData).garage_hand), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(lotInformationData).drive_side)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "lot-detail-label" }, "Driveway Placement", -1)),
              _createTextVNode(" " + _toDisplayString(_unref(lotInformationData).drive_side), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(lotInformationData).rear_grade)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "lot-detail-label" }, "Rear Grade", -1)),
              _createTextVNode(" " + _toDisplayString(_unref(lotInformationData).rear_grade), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(lotInformationData).address)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "lot-detail-label" }, "Address:", -1)),
              _createTextVNode(" " + _toDisplayString(_unref(lotInformationData).address && `${_unref(lotInformationData).address},`) + " " + _toDisplayString(_unref(lotInformationData).city) + " " + _toDisplayString(_unref(lotInformationData).state) + ", " + _toDisplayString(_unref(lotInformationData).zip), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(lotInformationData).public_note)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "lot-detail-label" }, "Public Notes", -1)),
              _createElementVNode("span", {
                ref_key: "publicNotesRef",
                ref: publicNotesRef,
                class: _normalizeClass(['lot-detail-value', { 'clamp-text': !isPublicNotesExpanded.value }])
              }, _toDisplayString(_unref(lotInformationData).public_note), 3),
              (showPublicReadMore.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "toggle-read",
                    onClick: togglePublicExpand
                  }, [
                    _createTextVNode(_toDisplayString(isPublicNotesExpanded.value ? 'Read Less' : 'Read More') + "  ", 1),
                    _createVNode(ArrowDownIcon, {
                      class: _normalizeClass({ 'rotate-180': isPublicNotesExpanded.value })
                    }, null, 8, ["class"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_unref(lotInformationData).private_note && isLandView.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "lot-detail-label" }, "Private Notes", -1)),
              _createElementVNode("span", {
                ref_key: "privateNotesRef",
                ref: privateNotesRef,
                class: _normalizeClass(['lot-detail-value', { 'clamp-text': !isPrivateNotesExpanded.value }])
              }, _toDisplayString(_unref(lotInformationData).private_note), 3),
              (showPrivateReadMore.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "toggle-read",
                    onClick: togglePrivateExpand
                  }, [
                    _createTextVNode(_toDisplayString(isPrivateNotesExpanded.value ? 'Read Less' : 'Read More') + "  ", 1),
                    _createVNode(ArrowDownIcon, {
                      class: _normalizeClass({ 'rotate-180': isPrivateNotesExpanded.value })
                    }, null, 8, ["class"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})